import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup,Validators } from '@angular/forms';

@Component({
  selector: 'app-time',
  templateUrl: './time.component.html',
  styleUrls: ['./time.component.css']
})
export class TimeComponent implements OnInit {
  
  @Input() hour;
  @Output()
   user_time=new EventEmitter();
  complexForm : FormGroup;
  fakeArray = new Array(12);
 
  constructor(
       fb: FormBuilder
        ) {
          this.complexForm = fb.group({
            'hour':['9'],
            'minuets':['15'],
            'am_pm':['AM']
     
      })
         }

  ngOnInit() {
     this.time();  
}
  time(){
    console.log(this.complexForm.value);
    let contact_time=this.complexForm.value.hour+':'+this.complexForm.value.minuets+' '+this.complexForm.value.am_pm;
    this.user_time.emit(contact_time);
 }

}



// WEBPACK FOOTER //
// ./src/app/shared/time/time.component.ts